<div class="time-range-form d-flex align-items-start gap-1 py-1" [attr.data-automation]="dataAutomation()">
  <ziro-time-select
    [fieldId]="'start'"
    [isFormSubmitted]="isFormSubmitted"
    [intervalMinutes]="timeIntervalMinutes()"
    data-automation="time-range-start"
  ></ziro-time-select>

  <span class="time-range-form__separator text-muted mt-2">–</span>

  <ziro-time-select
    [fieldId]="'end'"
    [isFormSubmitted]="isFormSubmitted"
    [intervalMinutes]="timeIntervalMinutes()"
    data-automation="time-range-end"
  ></ziro-time-select>

  @if (showDelete()) {
    <ziro-button
      [type]="ButtonTypes.BUTTON"
      [icon]="ZiroIcons.DELETE_SMALL"
      [buttonStyle]="ButtonStyles.OUTLINE_DANGER"
      [buttonSize]="ButtonSizes.MEDIUM"
      [dataAutomation]="'time-range-delete-button'"
      (clicked)="deleteClicked.emit()"
    ></ziro-button>
  }
</div>
